<template>
  <div class="md-layout page-bookinglist">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Booking") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Booking List") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table class="table-hover">
            <md-table-toolbar>
              <md-field class="md-layout-item md-small-size-100 md-size-20">
                <label for="pages">{{ $t("Per page") }}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="(item, position) in pagination.perPageOptions"
                    :key="position"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>
            </md-table-toolbar>
            <md-table-head>{{ $t("package") }}</md-table-head>
            <md-table-head>{{ $t("Client Name") }}</md-table-head>
            <md-table-head>{{ $t("Client Phone") }}</md-table-head>
            <md-table-head>{{ $t("Client Email") }}</md-table-head>
            <md-table-head>{{ $t("booking time") }}</md-table-head>
            <md-table-head>{{ $t("Flight Review No") }}</md-table-head>
            <md-table-head>{{ $t("Status") }}</md-table-head>
            <md-table-head>{{ $t("Earning") }}</md-table-head>
            <md-table-head>{{ $t("Edit") }}</md-table-head>
            <md-table-row
              v-for="(item, position) in bookingList"
              :key="position"
              @click="tableSelect(item)"
            >
              <md-table-cell>{{ item.package_title }}</md-table-cell>
              <md-table-cell>{{ item.customer_name }}</md-table-cell>
              <md-table-cell>{{ item.customer_phone }}</md-table-cell>
              <md-table-cell>{{ item.customer_email }}</md-table-cell>
              <md-table-cell>
                <md-button
                  v-if="
                    +item.event_status === 0 &&
                      item.always_available
                  "
                  @click.stop="showUpdateTimePopFn(item)"
                  class="md-primary md-just-icon md-simple"
                >
                  <md-icon>edit_calendar</md-icon>
                </md-button>
                <div v-if="item.booking_start_time">
                  {{
                    item.booking_start_time &&
                      moment(item.booking_start_time.$date)
                        .tz(item.review_timezone)
                        .format("YYYY-MM-DD HH:mm")
                  }}
                  -
                  {{
                    item.booking_end_time &&
                      moment(item.booking_end_time.$date)
                        .tz(item.review_timezone)
                        .format("HH:mm")
                  }}
                </div>
                <div>({{ item.review_timezone }})</div>
              </md-table-cell>
              <md-table-cell>{{ item.flight_review_no }}</md-table-cell>
              <md-table-cell
                :class="'status_' + EVENT_STATUS[item.event_status]"
                >{{ EVENT_STATUS[item.event_status] }}</md-table-cell
              >
              <md-table-cell
                >$ {{ (item.total / 100).toFixed(2) }}</md-table-cell
              >
              <md-table-cell class="btn-wrapper">
                <md-button
                  v-if="+item.event_status !== 4"
                  style="margin-right: 8px;"
                  @click.stop="toFeedback(item)"
                  class="md-primary md-just-icon  md-simple"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  v-if="
                    !item.always_available &&
                    item.booking_start_time &&
                    item.booking_start_time.$date > hrs3 &&
                    +item.event_status === 0
                  "
                  @click.stop="toCancel(item)"
                  class="md-primary md-just-icon md-simple"
                  ><md-icon>block</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              {{
                $t("Showing") +
                  " " +
                  (pagination.total === 0
                    ? 0
                    : (pagination.currentPage - 1) * pagination.perPage + 1) +
                  " " +
                  $t("to") +
                  " " +
                  (pagination.currentPage * pagination.perPage >
                  pagination.total
                    ? pagination.total
                    : pagination.currentPage * pagination.perPage) +
                  " " +
                  $t("of") +
                  " " +
                  pagination.total +
                  " " +
                  $t("entries")
              }}
            </p>
          </div>
          <pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            @pageChange="onPagination"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
    <md-progress-spinner
      md-mode="indeterminate"
      class="custom-page-spinner"
      v-if="loading"
    ></md-progress-spinner>
    <UpdateBookingTimePop
      :onclose="closeUpdateTimePop"
      :onsave="saveUpdateTimePop"
      :visiable="showUpdateTimePop"
      :bookingInfo="selectedBooking"
    />
  </div>
</template>

<script>
import {
  getReviewerBookingList,
  cancelBooking
} from "@/services/flightReview.service.js";
import moment from "moment-timezone";
import { Pagination } from "@/components";
import { EVENT_STATUS } from "@/const.js";
import swal from "sweetalert2";
import UpdateBookingTimePop from "./bricks/UpdateBookingTimePop.vue";

export default {
  components: {
    Pagination,
    UpdateBookingTimePop
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      },
      EVENT_STATUS,
      bookingList: [],
      hrs3: +new Date() + 3 * 60 * 60 * 1000, // 3 hours
      loading: false,
      showUpdateTimePop: false,
      selectedBooking: {}
    };
  },
  mounted() {
    let { currentPage, perPage } = this.pagination;
    this.getReviewerBookingListFn(currentPage, perPage);
  },
  methods: {
    moment: function(date) {
      return moment(date);
    },
    toFeedback(item) {
      this.$router.push(
        `/flight-review/reviewerFeedback?id=${item._id.$oid}&eventStatus=${
          item.event_status
        }&description=${item.description || ""}&flight_review_no=${(
          item.flight_review_no || ""
        ).replace("FR", "")}&allData=${JSON.stringify(item)}`
      );
    },
    toCancel(item) {
      if (this.loading) return;
      const _self = this;
      swal
        .fire({
          text: this.$t("Are you sure you want to cancel this booking?"),
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("No"),
          buttonsStyling: false
        })
        .then(async function({ value }) {
          if (!value) return;
          _self.loading = true;
          try {
            await cancelBooking({
              id: item._id.$oid,
              event_status: 4
            });
            _self.loading = false;

            _self.$notify({
              message: "Cancel success！",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success",
              timeout: 3000
            });
            let { currentPage, perPage } = _self.pagination;
            _self.getReviewerBookingListFn(currentPage, perPage);
          } catch {
            _self.loading = false;
          }
        });
    },
    async getReviewerBookingListFn(currentPage = 1, perPage = 10) {
      const { data, total } = await getReviewerBookingList({
        currentPage,
        perPage
      });
      this.bookingList = data ? JSON.parse(data) : [];
      console.log(this.bookingList);
      this.pagination = {
        perPage,
        currentPage,
        perPageOptions: [10, 25, 50, 100],
        total
      };
    },
    onPagination(currentPage) {
      this.getReviewerBookingListFn(currentPage, this.pagination.perPage);
    },
    showUpdateTimePopFn(item) {
      this.showUpdateTimePop = true;
      this.selectedBooking = item;
    },
    closeUpdateTimePop() {
      this.showUpdateTimePop = false;
    },
    saveUpdateTimePop() {
      this.showUpdateTimePop = false;
      let { currentPage, perPage } = this.pagination;
      this.getReviewerBookingListFn(currentPage, perPage);
    },
    tableSelect(item) {
      if (+item.event_status !== 4) {
        this.toFeedback(item)
      }
    }
  },
  watch: {
    "pagination.perPage": function(perPage) {
      this.pagination.currentPage = 1;
      this.getReviewerBookingListFn(1, perPage);
    }
  }
};
</script>

<style lang="css">
.page-bookinglist {
  .btn-wrapper .md-table-cell-container {
    padding-left: 0;
    width: 150px;
  }
  .md-table-cell-container .md-button {
    height: 32px;
    width: 70px;
  }
  .status_Fail {
    color: red;
  }
  .status_Pass {
    color: green;
  }
  .status_Cancelled {
    color: #999;
  }
}
</style>
